import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

// mute lint warnings as we're memoising this component so can't assign defaults
interface LoadingPanelProps {
  size?: number;
  loadingMessage?: string;
}

const LoadingPanel = React.memo(
  ({ size = 50, loadingMessage = undefined }: LoadingPanelProps) => (
    <Box
      data-testid="loading-panel"
      sx={{
        margin: '1rem 0',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Stack
        spacing={1}
        sx={{
          alignItems: 'center',
        }}
      >
        <CircularProgress size={size} sx={{ color: 'background.menuBorder' }} />
        {loadingMessage && <Typography>{loadingMessage}</Typography>}
      </Stack>
    </Box>
  )
);

export default LoadingPanel;
